import React from 'react';
import { pick } from 'lodash';
import { FormattedMessage } from 'react-intl';

import { Loader, Checkbox } from 'shared/components';
import FilterItem from '../../components/FilterItem';

const FilterByService = ({ services, servicesPending, setFilter, ...rest }) => {
  const filterItemProps = pick(rest, ['expanded', 'onChange', 'label', 'description']);

  return (
    <FilterItem { ...filterItemProps }>
      <Choose>
        <When condition={ servicesPending }>
          <div style={{ padding: '10px 0', textAlign: 'center', width: '100%' }}>
            <Loader color="#616161" />
          </div>
        </When>

        <When condition={ services.length === 0 }>
          <div style={{ padding: '16', textAlign: 'center', width: '100%' }}>
            <FormattedMessage
              id="Appointments.AppointmentsList.Filter.FilterOption.Service.EmptyList"
              defaultMessage="** You are not related to any services"
            />
          </div>
        </When>

        <Otherwise>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            { services.map(({ serviceId, name, checked }) => (
              <div style={{ margin: '10px 0' }} key={ serviceId }>
                <Checkbox
                  id={ serviceId }
                  tabIndex={ rest.expanded ? 0 : -1 }
                  checked={ checked }
                  onClick={ () => setFilter(serviceId) }
                  label={ name }
                />
              </div>
            )) }
          </div>
        </Otherwise>
      </Choose>
    </FilterItem>
  );
};

export default FilterByService;
